import * as React from 'react'
import styled from '@theme/styled-components'

interface Props {
  menu: JSX.Element
  content: JSX.Element
}

const ScreenContainer = ({ menu, content }: Props) => {
  const [screenHeight, setScreenHeight] = React.useState<number>(window.innerHeight)
  const [screenWidth, setScreenWidth] = React.useState<number>(window.innerWidth)

  React.useLayoutEffect(() => {
    const updateDimensions = () => {
      setScreenHeight(window.innerHeight)
      setScreenWidth(window.innerWidth)
    }
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  return (
    <Container screenHeight={screenHeight} screenWidth={screenWidth}>
      <MenuContainer>{menu}</MenuContainer>
      <MapContainer>{content}</MapContainer>
    </Container>
  )
}

export default ScreenContainer

const Container = styled('div')<{ screenHeight: number; screenWidth: number }>`
  display: flex;
  height: ${(props) => props.screenHeight}px;
  width: ${(props) => props.screenWidth}px;
`
const MenuContainer = styled('div')`
  z-index: 1;
  width: 450px;
  display: flex;

  background-color: ${(props) => props.theme.colors.menuBackground};
  box-shadow: 0px 0px 15px ${(props) => props.theme.colors.menuShadow};
`
const MapContainer = styled('div')`
  display: flex;
  flex: 3;
`
